import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

type Variant = "primary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

const variants: Record<Variant, string> = {
  primary:
    "bg-brand text-brand-fg hover:brightness-110 disabled:opacity-50",
  ghost:
    "bg-transparent text-fg border border-border hover:bg-bg-hover disabled:opacity-50",
  danger:
    "bg-danger/15 text-danger border border-danger/30 hover:bg-danger/25 disabled:opacity-50",
};

/** 基础按钮：高 32px，工具密度 */
export function Button({
  variant = "primary",
  className,
  children,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "inline-flex h-8 items-center justify-center gap-1.5 rounded-[var(--radius-sm)] px-3 text-[13px] font-medium transition-[background,filter,opacity] duration-[var(--dur)] ease-[var(--ease-out)]",
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
